import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { api, PrepTaskDto } from "../api/client";

/** Data d'avui a Europe/Madrid (YYYY-MM-DD), per saber quines tasques ja toca fer. */
function todayMadridStr(): string {
  return new Intl.DateTimeFormat("en-CA", {
    timeZone: "Europe/Madrid",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(new Date());
}

/**
 * Nombre de preparacions pendents (per avui o endarrerides). Usat a la campaneta
 * i al hub de perfil mòbil. `enabled=false` evita crides abans d'estar autenticat.
 */
export function usePendingPrepCount(enabled = true): number {
  const [count, setCount] = useState(0);
  const location = useLocation();

  useEffect(() => {
    if (!enabled) return;
    let alive = true;
    async function refresh() {
      try {
        const tasks = await api.get<PrepTaskDto[]>("/prep-tasks");
        if (!alive) return;
        const today = todayMadridStr();
        setCount(tasks.filter((t) => t.status === "pending" && t.dueDate <= today).length);
      } catch {
        /* silenciós: no ha de trencar la UI */
      }
    }
    refresh();
    const onFocus = () => refresh();
    window.addEventListener("focus", onFocus);
    window.addEventListener("naramenu:prep-changed", onFocus);
    return () => {
      alive = false;
      window.removeEventListener("focus", onFocus);
      window.removeEventListener("naramenu:prep-changed", onFocus);
    };
  }, [location.pathname]);

  return count;
}
